module.exports = __webpack_public_path__ + "static/media/icon-coupon.b9d7fea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/featured-cards/icons/icon-coupon.png
// module id = 2227
// module chunks = 0